// Smazání/obnovení komentáře

import { prepareFormData } from '@utils/form';
import * as els from './forumElements';
import * as api from './forumApi';
import { formChangeStatusComment as changeStatus } from './formChangeStatusComment';

interface ModalHarmlessState {
  msg: string;
}

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumHarmlessComment = (): void => {
  // UI a data modalu
  let state: ModalHarmlessState;
  const modal = els.modalHarmless;

  if (!modal) return;

  const buttonSave: HTMLButtonElement | null = modal.querySelector('[data-save-harmless-comment]');
  const { threadId } = modal.dataset;

  if (!buttonSave || !threadId) return;

  // Pro všechny tlačítka 'Nezávadné'
  els.buttonsHarmless.forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', () => {
      // Načtení dat komentáře
      const { harmlessComment: commentId } = button.dataset;
      if (commentId)
        state = {
          msg: commentId,
        };
    });
  });

  // V modálním okně po kliknutí na tlačítko 'OK'
  buttonSave.addEventListener('click', () => {
    const { msg } = state;

    if (!msg) return;

    // Přípravit data
    const requestData = prepareFormData({
      msg,
      status: '1',
      notify: '1',
      ajax: '1',
    });

    // Odeslat data
    changeStatus({
      apiRoute: api.status(threadId),
      requestData,
      successMessage: 'Komentář byl vyřazen z nahlášených.',
    });

    // Skrýt modal
    els.closeModal(modal);
  });
};
